export default __webpack_public_path__ + "static/media/pixels-project-2.9033215f.jpg";